/**
 * Lizenzen: Pakete, Grenzen und der Zustand einer Organisation.
 *
 * Bewusst hier und nicht im Server: Die Oberfläche muss dieselbe Rechnung
 * anstellen wie die API — sonst zeigt sie „noch 3 Tage", während der Server
 * längst sperrt. Es gibt genau eine Formel, und sie steht in dieser Datei.
 *
 * Das Preisschild ist Anzeige, keine Mechanik. Abgerechnet wird von Hand;
 * Præsto weiß nur, welches Paket vereinbart wurde und bis wann.
 */
/**
 * Ein Gigabyte im Dezimalsinn — dieselbe Rechnung wie in `formatBytes` und wie
 * auf jeder Festplattenverpackung. Mit 1024³ stünde im Angebot „50 GB" und in
 * der Anwendung „53,7 GB", und der Kunde hätte recht, wenn er nachfragt.
 */
const GB = 1_000_000_000;
export const ORG_PLANS = {
    demo: {
        label: 'plan.demo',
        members: 1,
        storageBytes: GB,
        monthlyEur: 0,
        hint: 'plan.demo.hint',
    },
    klein: {
        label: 'plan.klein',
        members: 3,
        storageBytes: 10 * GB,
        monthlyEur: 29,
        hint: 'plan.klein.hint',
    },
    team: {
        label: 'plan.team',
        members: 10,
        storageBytes: 50 * GB,
        monthlyEur: 79,
        hint: 'plan.team.hint',
    },
    gross: {
        label: 'plan.gross',
        members: 30,
        storageBytes: 200 * GB,
        monthlyEur: 199,
        hint: 'plan.gross.hint',
    },
};
export const ORG_PLAN_ORDER = ['demo', 'klein', 'team', 'gross'];
export function isOrgPlan(value) {
    return typeof value === 'string' && value in ORG_PLANS;
}
/** Ab wie vielen Tagen vor dem Ende gewarnt wird. */
export const WARN_DAYS = 14;
/** Wie lange nach dem Ablauf die Daten noch stehen bleiben. */
export const GRACE_DAYS = 21;
export const LICENSE_STATE_LABEL = {
    aktiv: 'license.state.aktiv',
    'laeuft-ab': 'license.state.laeuft-ab',
    abgelaufen: 'license.state.abgelaufen',
    'loeschung-faellig': 'license.state.loeschung-faellig',
};
/** Ganze Tage zwischen heute und einem ISO-Datum, in UTC gerechnet. */
export function daysUntil(isoDate, now = new Date()) {
    const [year, month, day] = isoDate.split('-').map(Number);
    const target = Date.UTC(year ?? 1970, (month ?? 1) - 1, day ?? 1);
    const today = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate());
    return Math.round((target - today) / 86_400_000);
}
export function licenseState(until, now = new Date()) {
    if (!until)
        return 'aktiv';
    const left = daysUntil(until, now);
    if (left < -GRACE_DAYS)
        return 'loeschung-faellig';
    if (left < 0)
        return 'abgelaufen';
    if (left <= WARN_DAYS)
        return 'laeuft-ab';
    return 'aktiv';
}
/** Darf diese Organisation gerade Neues anlegen? */
export function mayCreate(state) {
    return state === 'aktiv' || state === 'laeuft-ab';
}
/** Der Satz, der über der Board-Übersicht steht. `null` = kein Hinweis nötig. */
export function licenseNotice(license, t) {
    switch (license.state) {
        case 'aktiv':
            return null;
        case 'laeuft-ab':
            return t.plural(license.daysLeft ?? 0, 'license.notice.expiring.one', 'license.notice.expiring.many');
        case 'abgelaufen': {
            const left = GRACE_DAYS + (license.daysLeft ?? 0);
            return t.plural(left, 'license.notice.expired.one', 'license.notice.expired.many');
        }
        case 'loeschung-faellig':
            return t('license.notice.deletion');
    }
}
//# sourceMappingURL=license.js.map